
import React from 'react';
import { Navigate, Outlet,RouteProps } from 'react-router-dom';
import { Load } from '../components/Load';
import { useAuth } from '../hooks/auth';
import jwtDecode from 'jwt-decode'
interface RoutesPropsData extends RouteProps{
    type?: string;
}
const PrivateRoutes = ({ type, ...rest }: RoutesPropsData) => {
    let isAuth = false;
    const { user, loading } = useAuth();
    if(loading){
        return <div style={
            {width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent:'center',
            alignContent:'center'}
            }>
            <Load />
            </div>
    }
    if(!user.token){
        return <Navigate to="/login" />
    }
    const isExpired = jwtDecode(user.token) as { exp: number};
    if (user.token && isExpired.exp < Date.now() / 1000) {
        localStorage.clear();
        return <Navigate to="/login" />
    }

    if(!type && user){
        return <Outlet />
    }
    
    const findRole = type ? type.split(',').includes(user.type) : true;
    isAuth = findRole
    

    return isAuth ? <Outlet /> : <Navigate to="/login" />;
}
export default PrivateRoutes